import React, { Fragment, createContext, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useAppCtx, appStore } from "lib/state"
import { queryTools, cn } from "lib/utils"
import { DialogBox, Modal, TagsManager } from "lib/components"
import { ApiDataManager } from "lib/units/apidata"
import { ConditionalDropZone, ConditionalClipboard, SaveConditionalModal, TestConditionalModal, SpotlightItem, useConditional } from "lib/units/conditional"
import { useConditionalCtx } from "lib/units/dispute/statements/conditionals"

export default function ConditionalWorkingArea({ className="" }:{ className?:string }) {

  const { dspid } = useParams<{dspid:string}>()
  const { appState }:any = useAppCtx()
  const { store, AppStore }:any = appStore()

  const { currentConditional, handleConditionalSave, usage }:any = useConditionalCtx()
  const { addToClipboard, closeModal, closeSpotlight, saveConditional, saveConditionalObj, updateMetaData }:any = useConditional()  
  const { update }:any = AppStore

  const [ showSaveForm, setShowSaveForm ] = useState<boolean>(false)
  const [ formData, setFormData ] = useState<any>({ name: "", description: "" })
  const [ showTestModal, setShowTestModal ] = useState<boolean>(false)

  const { data:_Dispute } = queryTools.resource.parseQueryForApi("dispute.findById", { _id: dspid })
  const [ dialogConfig, setDialogConfig ] = useState<any>({ size: "xs", open: false, type: "info", title: "", cancel: { label: "Ok" } })

  const handleFieldChange = (e:React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, [e.target.name]: e.target.value })
  const handleSaveClick = () => {
    if( showSaveForm === false ){
      setShowSaveForm(true)
    } else {
      // console.log(currentConditional)
      // console.log(formData)
      handleConditionalSave(null, { ...currentConditional, ...formData })
      setShowSaveForm(false)
    }
  }

  const btnClasses = "flex justify-center items-center border border-solid border-teal-900 cursor-pointer px-2 bg-teal-800"
  const fieldClasses = "w-full h-full border border-solid border-slate-700 bg-slate-900 px-2 focus:outline-0"

  if( !currentConditional ) return <></>
  return ( 
    <div className={cn("w-full h-full flex flex-col p-[2px]")}> 

      <DialogBox {...dialogConfig} hideFn={() => setDialogConfig({...dialogConfig, open: false})}>
        <div className="w-full h-full">
          <p>Please provide a name for this conditional.</p>
        </div>
      </DialogBox>

      <SaveConditionalModal />
      <TestConditionalModal />

      <Modal status={store.metas.conditionalModal === "apidata" ? "open" : "closed"} size="2xl" rotate={false} title="API Datapoints" onClose={closeModal} showCloseBtn={true}>
          <ApiDataManager selectItemCallbackFn={addToClipboard} closeFn={closeModal} />
      </Modal>

      <Modal status={(store.metas.conditionalSpotlight !== null && store.metas.conditionalSpotlight !== undefined) ? "open" : "closed"} size="lg" rotate={true} title="Edit Item" onClose={closeSpotlight} showCloseBtn={true}>
        <SpotlightItem closeFn={closeSpotlight} /> 
      </Modal>

      <div className="w-full h-full flex flex-col border border-solid border-slate-700 relative">
        <div className="w-full std-block-title justify-between items-center pr-4">
          <div className="w-9/12 flex items-center">
            { showSaveForm === false ? 
              <span className="px-4 text-sm">staging area</span>
              :
              <div className="w-full">
                <form className="w-full flex justify-start items-center gap-3 px-1">
                  <input type="text" name="name" placeholder="Conditional Name" value={formData.name || ""} onChange={handleFieldChange} className={cn(fieldClasses, "w-3/12")} />
                  <input type="text" name="description" placeholder="Description" value={formData.description || ""} onChange={handleFieldChange} className={cn(fieldClasses, "w-9/12")} />
                  <div onClick={() => setShowSaveForm(false)} className={cn(btnClasses)}>cancel</div> 
                  <div onClick={handleSaveClick} className={cn(btnClasses)}>save</div> 
                </form>
              </div>
            }
          </div>

          <div className="w-3/12 flex justify-end items-center gap-2">
            <div onClick={() => update("metas.conditionalModal", "test-conditional")} className={cn(btnClasses)}>test conditionals</div>
            { usage === "conditionals" && (
              <div onClick={() => setShowSaveForm(true)} className={cn(btnClasses)}>save</div>
            )}
          </div>
        </div>
            
        <div className={cn("relative w-full h-full flex flex-col justify-start px-4 pb-3")}>
            
          {/* load all conditions by zone, and then by group  */} 
          <div className="w-full flex flex-col relative">
            <ConditionalDropZone  />
          </div>

            
          {/* { store.metas.conditionalClipboard?.length > -1 && (  */}
            <div className={cn( "w-full mt-6 flex flex-col h-full justify-start")}>
              <ConditionalClipboard />
            </div>
          {/* )} */}

        </div>
      </div>
    </div>
  )
}